<template>
  <router-link
    to="/expense-categories"
    class="card mx-3 mt-3 mb-3 text-decoration-none text-reset"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-tags me-2 text-primary" />
          {{ $t('Expense Categories') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ $t('Manage categories for expense records.') }}
        </div>
      </div>
      <i class="fa-solid fa-chevron-right text-muted" />
    </div>
  </router-link>
</template>

<script lang="js">
export default {
  name: 'ExpenseCategoriesSettingsCard'
};
</script>
